import { Checkbox } from "../../Checkbox"
import { ResponsiveDirection } from "../../../../../base/styles"
import { SelectFlexDirection } from "./SelectFlexDirection"
import clsx from "clsx"
import { useState } from "react"

export const EditFlexDirection = ({ title, value, className, onChange }: {
    title: string,
    value: ResponsiveDirection,
    className?: string,
    onChange: (value?: ResponsiveDirection) => void
}) => {
    const [responsive, setResponsive] = useState<boolean>();

    return (
        <div className={clsx(className)}>
            <div className="d-flex align-items-end">
                <SelectFlexDirection
                    title={title}
                    className="flex-grow-1 pe-2"
                    onChange={(newValue) => { onChange({ ...value, allSizes: newValue }) }}
                    value={value?.allSizes} />
                <Checkbox
                    title="Responsive"
                    className="fs-8 fw-semibold"
                    value={responsive === true}
                    onChange={setResponsive} />
            </div>

            {responsive &&
                <div className="d-flex flex-row flex-wrap mx-5 my-3">
                    <SelectFlexDirection
                        title="Small"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, small: newValue }) }}
                        value={value?.small} />
                    <SelectFlexDirection
                        title="Medium"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, medium: newValue }) }}
                        value={value?.medium} />
                    <SelectFlexDirection
                        title="Large"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, large: newValue }) }}
                        value={value?.large} />
                    <SelectFlexDirection
                        title="Ex. Large"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, xLarge: newValue }) }}
                        value={value?.xLarge} />
                    <SelectFlexDirection
                        title="Ex. Large +"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, xxLarge: newValue }) }}
                        value={value?.xxLarge} />
                </div>}
        </div>)
}